export default "__VITE_ASSET__LMMyHHZD__"